import axiosClient from "../../../../../system/helpers/axiosConfig";

export const getManageableList = () => {
  return axiosClient.get("api/admin/manageable-list").then((r) => r.data);
};
